
import { useAuthUserStore } from "@/stores/authUser";

export default function hasSelectedChild() {
    const authUserStore = useAuthUserStore();
    const u = authUserStore.user;
    if (!u.related.selected_child) {
        return {
            name: "child-select"
        };
    }
}
